const vAdminformat = {};

vAdminformat.FormatDate = function FormatDateString(isoDate) {

  if (!isoDate || isoDate === null || isoDate === '') {
    return null
  }

  const date = new Date(isoDate);

  const options = {
    year: 'numeric',
    month: 'short', // 'Short' to abbreviate the month (example: "aug")
    day: 'numeric',
    hour12: false // Change to True if you prefer 12 hours format

  };

  return date.toLocaleString('en-UK', options);
}

vAdminformat.FormatDateTime = function FormatDateString(isoDate) {

  if (!isoDate || isoDate === null || isoDate === '') {
    return null
  }

  const date = new Date(isoDate);

  const options = {
    year: 'numeric',
    month: 'short', // 'Short' to abbreviate the month (example: "aug")

    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: false // Change to True if you prefer 12 hours format

  };

  return date.toLocaleString('en-UK', options);
}

vAdminformat.FormatDateSmall = function FormatDateString(isoDate) {

  if (!isoDate || isoDate === null || isoDate === '') {
    return null
  }

  const date = new Date(isoDate);

  const options = {
    year: 'numeric',
    month: 'short', // 'Short' to abbreviate the month (example: "aug")

    day: 'numeric',
    hour12: false // Change to True if you prefer 12 hours format

  };

  return date.toLocaleString('en-UK', options);
}

vAdminformat.FormatMoney = function FormatMoney(dataMoney) {

  const date = parseFloat(dataMoney);


  if (isNaN(date)) {
    return (0).toLocaleString('en-UK', {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: 2
    });
  }


  return date.toLocaleString('en-UK', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 2
  });
};

/* Global function to use */
vAdminformat.truncateText = function truncateText(text, limit){
  if (text && text.length > limit) {
    return text.substring(0, limit) + '...';
  }
  return text;
};


export default vAdminformat;